import {defineStore} from 'pinia';
import {ModuleDvcBudget} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import dvcBudgetApi from '@/apis/di/dvcBudgetApi';

const dvcBudgetStore = new BaseDictionaryStore(dvcBudgetApi);

export const useDvcBudgetStore = defineStore(ModuleDvcBudget, {
  state: () => ({
    ...dvcBudgetStore.state,
    _config: {
      key: 'dvc_budget_id',
      code: 'budget_code',
      name: 'budget_name',
      table: 'dvc_budget',
      moduleName: 'ĐVQHNS/ Dự án',
      defaultSort: 'created_date',
    },
    moduleName: ModuleDvcBudget,
  }),
  actions: {
    ...dvcBudgetStore.action,

    /**
     * Cập nhật thiết lặp mã hồ sơ
     * @param {*} payload
     * @returns
     * nhhoang1 12.03.2024
     */
    async updateSettingFileCode(payload) {
      const res = await dvcBudgetApi.updateSettingFileCode(payload);

      // cập nhật
      if (res) {
        this.items.filter(e => {
          if (e.dvc_budget_id == payload.dvc_budget_id) {
            e.file_code_sub_fix = payload.file_code_sub_fix;
            e.ref_no_sub_fix = payload.ref_no_sub_fix;
            e.file_code_sub_fix_dcsd = payload.file_code_sub_fix_dcsd;
          }

          return true;
        });
      }

      return res;
    },
  },
  getters: {
    ...dvcBudgetStore.getters,
  },
});
